export default __webpack_public_path__ + "static/media/character.28aad526.png";